import { composeClassNames, getImageUrl } from "@faedev/editor-utils";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Alert, Button, Image, Navbar } from "react-bootstrap";
import { useCookies } from "react-cookie";
import MenuMain from "src/components/MenuMain";
import Search from "src/components/Search";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getLink from "src/functions/getLink";
import Small_cancel from "src/icons/Small-cancel";
import { sAlert } from "src/styles/sAlert.module.scss";
import { sButton } from "src/styles/sButton.module.scss";
import { sButtonClose } from "src/styles/sButtonClose.module.scss";
import { sLogo } from "src/styles/sLogo.module.scss";
import { sNavbar } from "src/styles/sNavbar.module.scss";
import { sNavbarCollapse } from "src/styles/sNavbarCollapse.module.scss";
import { sNavbarToggle } from "src/styles/sNavbarToggle.module.scss";
import { sQuickPlay } from "src/styles/sQuickPlay.module.scss";

function Header() {
  const { locale: lang } = useRouter();
  const [cookies, setCookie] = useCookies(["alertSell"]);
  const [alertResetPassword, setAlertResetPassword] = useState(false);

  useEffect(() => {
    const timeId = setTimeout(() => {
      // After 10 seconds set the show value to false
      setAlertResetPassword(false);
    }, 10000);

    return () => {
      clearTimeout(timeId);
    };
  }, [alertResetPassword]);

  return (
    <>
      <Navbar expand={`lg`} sticky={`top`} className={sNavbar}>
        <Link href={"/"} passHref>
          <Navbar.Brand href={`/` + constants.Locales._default.lang + `/`}>
            <Image
              src={getImageUrl("/images/logo_anandita_yoga.svg")}
              className={sLogo}
              alt="Anandita logo"
            />
          </Navbar.Brand>
        </Link>
        {constants.Show.navQuickplay ? (
          <Button
            variant={`link`}
            className={sQuickPlay}
            style={{ padding: "0" }}
          >
            <Image
              src={getImageUrl("/images/quick-play.svg")}
              alt="Quick play"
            />
          </Button>
        ) : null}
        <Navbar.Toggle
          className={sNavbarToggle}
          style={{ padding: "0" }}
        ></Navbar.Toggle>
        <Navbar.Collapse className={sNavbarCollapse}>
          {constants.Show.navSearch ? <Search /> : null}
          <MenuMain setAlertResetPassword={setAlertResetPassword} />
        </Navbar.Collapse>
      </Navbar>
      <div>
        {!cookies.alertSell ? (
          <Alert
            variant={`info`}
            className={composeClassNames([sAlert, "alert-flash"])}
          >
            <strong className="mr-3">
              <Translate tKey={`Are you a yoga instructor? Join us and get`} />
              {` ${constants.Marketing.contribution} `}
              <Translate tKey={`CZK for promotion.`} />
            </strong>
            <Link href={getLink(lang, `join-us`, null)} passHref>
              <Button
                variant={`primary`}
                as={`a`}
                className={composeClassNames([sButton, "btn-cta"])}
                size={`sm`}
              >
                <Translate tKey={`Become an Anandita instructor`} />
              </Button>
            </Link>
            <Button
              variant={`link`}
              onClick={() => setCookie(`alertSell`, false, { path: "/" })}
              size={`sm`}
              className={composeClassNames([sButtonClose, `btn-close`])}
            >
              <Small_cancel />
            </Button>
          </Alert>
        ) : (
          <></>
        )}
      </div>
      {alertResetPassword && (
        <Alert variant={`success`} className={sAlert}>
          <Translate
            tKey={`A password reset link has been sent to the email.`}
          />
        </Alert>
      )}
    </>
  );
}

export default Header;
